import { useState, useEffect } from "react";
import DSBox from "../../views/system-design/DSBox";
import DSTypography from "../../views/system-design/DSTypography";
import DSTextField from "../../views/system-design/DSTextField";
import DSMenuItem from "../../views/system-design/DSMenuItem";

const SimpleDropdown = (props: {
  title: string;
  list: Array<string>;
  default: string;
  onSelect: (s: string) => void;
  disabled?: boolean;
}) => {
  const [curr, setCurr] = useState(props.default);

  useEffect(() => {
    setCurr(props.default);
  }, [props.default]);

  return (
    <DSBox
      sx={{
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        pl: 2.5,
        pt: 1.5,
        gap: 2,
      }}
    >
      <DSBox sx={{ width: { xxs: "100%", sm: "42%", md: "33%" } }}>
        <DSTypography sx={{ fontWeight: 700 }}>{props.title}</DSTypography>
      </DSBox>
      <DSTextField
        select
        size="small"
        disabled={props.disabled}
        value={curr}
        sx={{ minWidth: 150, width: { xxs: "100%", sm: "50%" } }}
        onChange={(e) => {
          props.onSelect(e.target.value);
          setCurr(e.target.value);
        }}
      >
        {props.list.map((s) => (
          <DSMenuItem key={s} value={s}>
            {s.toLowerCase()}
          </DSMenuItem>
        ))}
      </DSTextField>
    </DSBox>
  );
};

export default SimpleDropdown;
